/**
 * State Timeline constants — colors keyed by the actual eventName from the API.
 */

export const EVENT_COLORS = {
  "Charging Started": "#3b82f6",
  "EV Plugged In": "#22c55e",
  "EV Plugged Out": "#ef4444",
  "Charging Stopped": "#f59e0b",
  "Fault Detected": "#dc2626",
  "Fault Cleared": "#06b6d4",
};

export const DEFAULT_SEGMENT_COLOR = "#94a3b8";

export const MARGIN = { top: 10, right: 20, bottom: 30, left: 20 };

export const TIMELINE_BAR_HEIGHT = 36;
export const TIMELINE_BAR_RADIUS = 6;

export const TICK_COUNT = 6;
export const LABEL_CHAR_WIDTH = 7;
export const ABBREV_MIN_WIDTH = 30;
export const X_AXIS_GAP = 6;
export const X_AXIS_EXTRA_HEIGHT = 20;
export const DAY_MS = 86400000;
export const NOW_INDICATOR_THRESHOLD_MS = 60000;
